import styled from 'styled-components/native';

export const WorkoutContainerText = styled.Text`
  font-size: 16px;
  font-weight: 500;
  color: #282F63;
  font-family: 'Montserrat-SB';
`;

export const WorkoutContainerHeaderThree = styled.Text`
  font-size: 16px;
  font-weight: 800;
  color: #38406f;
  font-family: 'Montserrat-EB';
`

export const WorkoutContainerHeaderTwo = styled.Text`
  font-size: 17px;
  font-weight: 600;
  color: #3366CC;
  font-family: 'Montserrat-SB';
`

export const WorkoutTextHeader = styled.Text`
  font-size: 18px;
  font-weight: 700;
  color: #3366CC;
  font-family: 'PresicavRb-RG';
  transform: scale(1, 1.15);
  margin-top: -7.5px;
`;

export const WorkoutTextSubHeader = styled.Text`
  font-size: 14px;
  font-weight: 900;
  color: #C04C97;
  font-family: 'Montserrat-BK';
  letter-spacing: 0px;
`;

export const WorkoutCommonButton = styled.TouchableOpacity`
  font-size: 10px;
  letter-spacing: 1px;
  width: auto;
  padding-left:35px;
  padding-right:35px;
  height: 35px;
  background: #3366cc;
  color: white;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  font-family: 'Montserrat-SB';
`;

export const WorkoutCommonButtonTwo = styled.TouchableOpacity`
  font-size: 10px;
  letter-spacing: 1px;
  width: auto;
  padding-left:15px;
  padding-right:15px;
  height: 35px;
  background: transparent;
  border:2px solid #c04c97;
  color: white;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
`;

export const WorkoutButtonTwo = styled.TouchableOpacity`
  background:#c04c97;
  height:25px;
  width:auto;
  padding-left:25px;
  padding-right:25px;
  display:flex;
  justify-content:center;
  align-items:center;
  border-radius:50px;
`
